import React from 'react';
import { APP_CONTAINER_ROUTES, CHECK_IN_ROUTES } from './routes';
import { AppContainerStackParams, CheckInStackParams } from './types';
import { CheckInContextProvider } from '@/contexts/check-in-context';
import { CheckInReportAnIssueScreen } from '@/screens/check-in-report-an-issue-screen';
import { CheckInSingleItemScreen } from '@/screens/check-in-single-item-screen';
import { createStackNavigator } from '@react-navigation/stack';
import {
  flexModalCardStyle,
  useModalStackScreenOptions,
} from '@/hooks/use-modal-stack-screen-options';
import { OrderCheckInScreen } from '@/screens/order-check-in/order-check-in-screen';
import { RouteProp, useRoute } from '@react-navigation/native';

const Stack = createStackNavigator<CheckInStackParams>();

type RouteProps = RouteProp<
  AppContainerStackParams,
  typeof APP_CONTAINER_ROUTES.OrderCheckIn
>;

export const OrderCheckInStack: React.FC = () => {
  const modalScreenOptions = useModalStackScreenOptions();
  const route = useRoute<RouteProps>();
  const { checkInCompleted, checkInUUID, invoiceUUID, orderUUID } =
    route.params;
  return (
    <CheckInContextProvider checkInUUID={checkInUUID}>
      <Stack.Navigator
        initialRouteName={CHECK_IN_ROUTES.Base}
        screenOptions={modalScreenOptions}
      >
        <Stack.Screen
          component={OrderCheckInScreen}
          initialParams={{
            checkInCompleted,
            invoiceUUID,
            orderUUID,
          }}
          name={CHECK_IN_ROUTES.Base}
        />
        <Stack.Screen
          component={CheckInSingleItemScreen}
          name={CHECK_IN_ROUTES.CheckInSingleItem}
          options={{ cardStyle: flexModalCardStyle }}
        />
        <Stack.Screen
          component={CheckInReportAnIssueScreen}
          name={CHECK_IN_ROUTES.CheckInReportAnIssue}
          options={{ cardStyle: flexModalCardStyle }}
        />
      </Stack.Navigator>
    </CheckInContextProvider>
  );
};
